import React from "react";
import {WizTableForm} from '@/containers/common'
import {mergeColumns} from '../../utils';

const program = WizTableForm.Config.program(this, {apiParams: {isPower: false}})
const organization = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const position = WizTableForm.Config.position(this, {apiParams: {state: 1}})
const user = WizTableForm.Config.user(this, {apiParams: {state: 1}})

//配置项
const componentName = "programReport";
//课程验证
const programIdListValidator = (rule, value, callback) => {
  if (value && value.length > 10) {
    wizNotice.warn('课程最多选择10个')
    callback('课程最多选择10个')
  }
  callback();
}
function columns() {
  const columns = [
    {
      name: "id",
    },
    {
      title: "课程名称",
      name: "programName",
      tableItem: {},
    },
    // {
    //   title: "课程名称",
    //   name: "programId",
    //   searchItem: {
    //     ...program,
    //     diy: WizTableForm,
    //     selectType: 'radio',
    //     rules: [
    //       {
    //         required: true,
    //         message: '请选择课程名称'
    //       }
    //     ]
    //   },
    // },
    {
      title: "课程名称",
      name: "programIdList",
      searchItem: {
        ...program,
        diy: WizTableForm,
        selectType: 'checkbox',
        rules: [
          {
            required: true,
            message: '请选择课程'
          },
          {
            validator: programIdListValidator
          }
        ]
      },
    },
    {
      title: "课程编码",
      name: "scoId",
      tableItem: {},
    },
    {
      title: "课程分类",
      name: "programCategoryName",
      tableItem: {
        type: 'popover'
      },
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    {
      title: "学员身份证",
      name: "idCard",
      tableItem: {},
    },
    {
      title: "dp账号状态",
      name: "dpAvtiveStatusCn",
      tableItem: {},
    },
    {
      title: "dp人脸识别结果",
      name: "dpAuthenRecordCn",
      tableItem: {},
    },
    {
      title: "账号状态",
      name: "accountState",
      searchItem: {
        type: 'select'
      },
      tableItem: {},
      dict: [
        {code: 0, codeName: '禁用'},
        {code: 1, codeName: '激活'},
      ]
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "orgTypeName",
      tableItem: {},
    },
    {
      title: "组织类型",
      name: "nodeCategory",
      dict: {
        wizReplaceData: "orgNodeCategoryTree",
        defalutType: []
      },
      searchItem: {
        type: 'treeselect',
        allowClear: true,
        treeCheckable: true,
        treeCheckStrictly: true
      }
    },
    {
      title: "上级组织",
      name: "leadName",
      tableItem: {},
    },
    {
      title: "上级组织",
      name: "parentOrgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionIds",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      tableItem: {},
      dict: [
        {code: 0, codeName: '离职'},
        {code: 1, codeName: '在职'},
      ]
    },
    {
      title: "课程完成率",
      name: "finishRate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "状态",
      name: "pass",
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 0, codeName: '未通过'},
        {code: 1, codeName: '通过'},
      ]
    },
    {
      title: "开始学习时间",
      name: "firstTime",
      tableItem: {},
    },
    {
      title: "末次学习时间",
      name: "lastTime",
      tableItem: {},
    },
    {
      title: "课程通过时间",
      name: "passDate",
      tableItem: {},
    },
  ];

  return mergeColumns.call(this, columns, [])
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign({}, v)
            if (value['nodeCategory'] && value['nodeCategory'].length) {
              value['nodeCategoryIds'] = value['nodeCategory'].map(nodeCategory => nodeCategory.value)
            } else {
              value['nodeCategoryIds'] = undefined
            }
            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageList`,
    payload: {
      key: `${componentName}@getPageList`,
      apiParams: {pageNum: 1, pageSize: 10},
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  orgNodeCategoryTree: {
    path: `organizationNodeCategory/getTypeNodeList`,
    payload: {
      key: `${componentName}@orgNodeCategoryTree`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "orgNodeCategoryTree"],
    needLoading: true,
    ...args,
  };
};

export {reduxTemplateCofig, templateConfig};
